import React from "react";
import { Container, Spinner } from "react-bootstrap";

interface SpinnerCustomProps {
  variant?: string;
}

const SpinnerCustom: React.FC<SpinnerCustomProps> = ({
  variant = "primary",
}) => {
  return (
    <Container className="py-5 d-flex justify-content-center">
      <Spinner variant={variant} animation="border" />
    </Container>
  );
};

export default SpinnerCustom;
